import { request } from "@/utils/request";
import { BASE_URL } from '@/constants/config';
import { ActiveUser } from "@/services/user";

export const AUTH_ENDPOINTS = {
  login: `${BASE_URL}auth/jwt/login`,
  logout: `${BASE_URL}auth/jwt/logout`,
  forgotPassword: `${BASE_URL}auth/forgot-password`,
  resetPassword: `${BASE_URL}auth/reset-password`,
};

class Auth {
  async forgotPassword(email) {
    return await request({
      url: AUTH_ENDPOINTS.forgotPassword,
      method: "POST",
      skipRedirect: true,
      body: {
        email,
      },
    });
  }

  async resetPassword({ password, token }) {
    return await request({
      url: AUTH_ENDPOINTS.resetPassword,
      method: "POST",
      skipRedirect: true,
      body: {
        password,
        token,
      },
    });
  }

  async login({ email, password }) {
    const formData = new FormData();
    formData.append("password", password);
    formData.append("username", email);
    const { data, res } = await request({
      url: AUTH_ENDPOINTS.login,
      method: "POST",
      skipRedirect: true,
      formData,
    });
    if (res.status === 200) {
      await ActiveUser.set({ accessToken: data.access_token, email });
    }
    return {
      data,
      res,
    };
  }

  async logout(token) {
    return await request({
      url: AUTH_ENDPOINTS.logout,
      query: { token },
      method: "POST",
      skipRedirect: true,
    });
  }
}

export const AuthService = new Auth();
